<template>
  <MonitorsList/>
</template>
<script>
import MonitorsList from '@/components/modules/schoolroutes/monitors/list'
export default {
  name: 'monitors',
  components: {
    MonitorsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/monitors/list.vue